/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReingestRequest } from './ReingestRequest';
import {
    ReingestRequestFromJSON,
    ReingestRequestFromJSONTyped,
    ReingestRequestToJSON,
} from './ReingestRequest';

/**
 * 
 * @export
 * @interface ListReingestRequestsResponseBody
 */
export interface ListReingestRequestsResponseBody {
    /**
     * 
     * @type {Array<ReingestRequest>}
     * @memberof ListReingestRequestsResponseBody
     */
    items: Array<ReingestRequest>;
    /**
     * A cursor for use in the subsequent call.
     * @type {string}
     * @memberof ListReingestRequestsResponseBody
     */
    startingAfter?: string;
    /**
     * The total number of items in the collection.
     * @type {number}
     * @memberof ListReingestRequestsResponseBody
     */
    totalCount: number;
}

/**
 * Check if a given object implements the ListReingestRequestsResponseBody interface.
 */
export function instanceOfListReingestRequestsResponseBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "totalCount" in value;

    return isInstance;
}

export function ListReingestRequestsResponseBodyFromJSON(json: any): ListReingestRequestsResponseBody {
    return ListReingestRequestsResponseBodyFromJSONTyped(json, false);
}

export function ListReingestRequestsResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListReingestRequestsResponseBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ReingestRequestFromJSON)),
        'startingAfter': !exists(json, 'starting_after') ? undefined : json['starting_after'],
        'totalCount': json['total_count'],
    };
}

export function ListReingestRequestsResponseBodyToJSON(value?: ListReingestRequestsResponseBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(ReingestRequestToJSON)),
        'starting_after': value.startingAfter,
        'total_count': value.totalCount,
    };
}

